import { connect } from 'react-redux';
import { bindActionCreators } from 'multireducer';

import { getVideosByIds } from 'shared/selectors/videos';
import { isFetching } from 'shared/selectors/channel-videos';

import {
  loadFirstPage,
  loadMore,
} from 'widget/redux/client/actions/channel-videos-lazy-load';

import DataLoader from 'shared/data-components/_data-loader';

export const MOBILE_WIDGET_DATA_KEY = 'mobileWidget';
export const MOBILE_SEARCH_DATA_KEY = 'mobileSearch';
export const MOBILE_OVERLAY_DATA_KEY = 'mobileOverlay';

@connect(
  (state, { as }) => ({
    videoByIds: getVideosByIds(state, state.lazyVideoLists[as].videoIds),
    ids: state.lazyVideoLists[as].videoIds,
    nextVideosCursor: state.lazyVideoLists[as].nextVideosCursor,
    category: state.lazyVideoLists[as].category,
    isFetching: isFetching(state),
  }),
  (dispatch, { as }) => bindActionCreators({
    loadFirstPage,
    loadMore,
  }, dispatch, as)
)
export default class LazyChannelVideosLoader extends DataLoader {

  static displayName = 'LazyChannelVideosLoader';

  static propTypes = {
    loadFirstPage: React.PropTypes.func,
    numberToLoadMore: React.PropTypes.number,
    nextVideosCursor: React.PropTypes.string,
    category: React.PropTypes.string,
    tag: React.PropTypes.string,
    query: React.PropTypes.string,
    channelId: React.PropTypes.string,
  };

  static defaultProps = {
    numberToLoadMore: 8,
  };

  dependencies = [
    'channelId',
    'category',
    'tag',
    'query',
  ];

  loadData() {
    const { channelId, loadFirstPage, numberToLoadMore, category, tag, query } = this.props;

    if (!channelId) {
      return;
    }

    // TODO: move getChannel code here
    return loadFirstPage(numberToLoadMore, {
      category,
      tag,
      query,
    });
  }

  get childProps() {
    const { videoByIds, ids, isFetching, loadMore, numberToLoadMore, nextVideosCursor } = this.props;

    // TODO: move this logic to view components
    const loadMoreWrapped = itemsShown => {
      const threshold = numberToLoadMore / 2;
      if (nextVideosCursor && (_.size(ids) - itemsShown) < threshold) {
        return loadMore(numberToLoadMore, nextVideosCursor);
      }
      return Promise.resolve();
    };
    const loadMoreWrappedNoSimultaneous = this.onceAtTime(loadMoreWrapped);

    return {
      videoByIds,
      lazyChannelVideos: {
        ids,
        isFetching,
        fetch: this.loadDataDebounced,
        //TODO: use actions to call loadMore
        loadMore: loadMoreWrappedNoSimultaneous,
      },
    };
  }

}



// WEBPACK FOOTER //
// ./src/widget/data-components/lazy-channel-videos.js